import { makeStyles } from '@mui/styles'
import * as React from 'react'

import type { Theme } from '../../design-tokens/theme'
import { DialogContent } from '../../primitives/Dialog'

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: `0 ${theme.spacing(8)} ${theme.spacing(4)} ${theme.spacing(8)}`,
  },
}))

const SimpleDialogContent: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const classes = useStyles()

  return <DialogContent className={classes.content}>{children}</DialogContent>
}

export default SimpleDialogContent
